import React from 'react'
import { Authenticator } from '@aws-amplify/ui-react'

const Login: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center fade-in">
          <div className="text-6xl mb-4 text-blue-500">🔗</div>
          <h1 className="text-display text-gray-900 mb-2">URL Shortener</h1>
          <p className="text-body text-gray-600">
            Sign in with your Google Workspace account
          </p>
        </div>
        
        <div className="card space-inside-lg fade-in">
          <Authenticator 
            hideSignUp={true}
            socialProviders={['google']}
          >
            {({ signOut, user }) => (
              <div className="space-y-4">
                <h2 className="text-heading text-gray-900 text-center">
                  Welcome, {user?.username}
                </h2>
                <button
                  onClick={signOut}
                  className="btn-danger w-full"
                >
                  Sign Out
                </button>
              </div>
            )}
          </Authenticator>
        </div>
      </div>
    </div>
  )
}

export default Login